<div
  [ngClass]="{ 'ckyc-poa': isTwoObject, 'ckyc-document': !isTwoObject }"
  class="res-view"
>
  <div mat-dialog-title>
    <div class="document-popup-header d-flex justify-content-end">
      <img
        src="assets/icon/cross.svg"
        (click)="isUploadDocment ? reUploadDone('close') : popupCLose()"
        class="cursor-pointer"
        alt="close"
      />
    </div>
  </div>
  <div mat-dialog-content>
    <form
      [formGroup]="uploadDocumentsForm"
      (ngSubmit)="submitUploadDocumentsForm(uploadDocumentsForm.valid)"
      novalidate
    >
      <div class="row">
        <div class="col-12">
          <p [ngClass]="{ 'text-center': !isTwoObject }">
            {{ documentHeaderText }}
          </p>
        </div>
        <div
          [ngClass]="{
            'col-12 col-lg-4': isTwoObject,
            'col-12 ': !isTwoObject
          }"
        >
          <mat-form-field
            appearance="outline"
            class="document-list mat-input-custom"
            [hidden]="isUploadDocment"
          >
            <mat-label>Select Document Type</mat-label>
            <mat-select
              formControlName="document_type_based_field"
              (ngModelChange)="getDocumentKey($event)"
            >
              <mat-option
                *ngFor="let document of documentList"
                [value]="document?.document_code"
              >
                {{ document?.document_name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                uploadDocumentsForm
                  .get('document_type_based_field')
                  ?.hasError('required')
              "
            >
              This is a required field.
            </mat-error>
          </mat-form-field>
        </div>
        <ng-container *ngIf="showPOA">
          <ng-container
            *ngFor="let fields of formFieldPOA | keyvalue; let i = index"
          >
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'dropdown'"
            >
              <mat-form-field
                appearance="outline"
                class="document-list mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <mat-select
                  {{
                  fields?.value?.name
                  }}`
                  [formControlName]="fields?.value?.lable"
                >
                  <mat-option
                    *ngFor="let list of fields?.value?.dropdown_list"
                    [value]="list?.key"
                  >
                    {{ list?.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value.lable)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'string'"
            >
              <mat-form-field
                appearance="outline"
                class="document_number mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  [formControlName]="fields?.value?.label"
                  matInput
                  aria-label="document_number"
                  class="text-uppercase"
                  [maxlength]="documentMaxLength"
                />
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('pattern')
                  "
                >
                  Invalid Document Number
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'dob'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="dobDate"
                  [formControlName]="fields?.value?.label"
                  id-automation="`${fields?.value?.name}`"
                  #dobDateInput
                  appDateFormat
                  [max]="maxDate"
                  [min]="minDate"
                />
                <mat-datepicker-toggle matSuffix [for]="dobDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #dobDate
                  startView="multi-year"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'doi'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="doiDate"
                  [formControlName]="fields?.value?.label"
                  id-automation="`${fields?.value?.name}`"
                  #doiDateInput
                  appDateFormat
                  [max]="maxDoiDate"
                  [min]="minDoiDate"
                />
                <mat-datepicker-toggle matSuffix [for]="doiDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #doiDate
                  startView="multi-year"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'upload'"
            >
              <div
                class="form-group"
                *ngIf="fields?.value?.label === 'poa_doc_url'"
              >
                <label class="lable-file-input" for="fileInput">
                  <p class="file-input-text">
                    {{ POAFileName == "" ? fields?.value?.name : POAFileName }}
                  </p>
                </label>
                <img
                  src="{{
                    POAFileName === ''
                      ? 'assets/icon/upload.svg'
                      : 'assets/icon/see.svg'
                  }}"
                  alt=""
                  class="upload-doc-image"
                  (click)="
                    POAFileName === ''
                      ? null
                      : checkUploadDocment(uploadDocumentsForm.get(fields?.value?.label)?.value,fields?.value?.label)
                  "
                />
                <input
                  type="file"
                  id="fileInput"
                  class="form-control-file"
                  (change)="onFileSelected($event, fields?.value?.label)"
                />
                <input type="hidden" [formControlName]="fields?.value?.label" />
                <div *ngIf="isfileInputError" class="text-danger">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
                <div *ngIf="fileInputError" class="error-msg">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
              </div>
              <div
                class="form-group mt-2"
                *ngIf="fields?.value?.label === 'poa_doc_url_1'"
              >
                <label class="lable-file-input" for="fileInput1">
                  <p class="file-input-text">
                    {{
                      POAFileName1 == "" ? fields?.value?.name : POAFileName1
                    }}
                  </p>
                </label>
                <img
                  src="{{
                    POAFileName1 === ''
                      ? 'assets/icon/upload.svg'
                      : 'assets/icon/see.svg'
                  }}"
                  alt=""
                  class="upload-doc-image"
                  (click)="
                    POAFileName1 === ''
                      ? null
                      : checkUploadDocment(uploadDocumentsForm.get(fields?.value?.label)?.value,fields?.value?.label)
                  "
                />
                <input
                  type="file"
                  id="fileInput1"
                  class="form-control-file"
                  (change)="onFileSelected($event, fields?.value?.label)"
                />
                <input type="hidden" [formControlName]="fields?.value?.label" />

                <div *ngIf="isfileInputError1" class="text-danger">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
                <div *ngIf="fileInputError1" class="error-msg">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showPOI">
          <div class="col-12 mt-4">
            <p [ngClass]="{ 'text-center': !isTwoObject }">
              {{ documentPOIText }}
            </p>
          </div>

          <ng-container
            *ngFor="let fields of formFieldPOI | keyvalue; let i = index"
          >
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'dropdown'"
            >
              <mat-form-field
                appearance="outline"
                class="document-list mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <mat-select
                  [formControlName]="fields?.value?.lable"
                  (selectionChange)="
                    onSelectionChange($event, fields?.value?.label)
                  "
                >
                  <mat-option
                    *ngFor="let list of fields?.value?.dropdown_list"
                    [value]="list?.key"
                  >
                    {{ list?.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'string'"
            >
              <mat-form-field
                appearance="outline"
                class="document_number mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  [formControlName]="fields?.value?.label"
                  matInput
                  aria-label="document_number"
                  class="text-uppercase"
                />
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'dob'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="dobDate"
                  [formControlName]="fields?.value?.label"
                  #dobDateInput
                  appDateFormat
                  [max]="maxDate"
                  [min]="minDate"
                  (click)="dobDate.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="dobDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #dobDate
                  startView="multi-year"
                  id-automation="`${fields?.value?.name}`_id"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'doi'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }} </mat-label>
                <input
                  matInput
                  [matDatepicker]="doiDate"
                  [formControlName]="fields?.value?.label"
                  #doiDateInput
                  appDateFormat
                  [max]="maxDoiDate"
                  [min]="minDoiDate"
                />
                <mat-datepicker-toggle matSuffix [for]="doiDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #doiDate
                  startView="multi-year"
                  id-automation="`${fields?.value?.name}`_id"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'upload'"
            >
              <div class="form-group">
                <label class="lable-file-input" for="fileInputPOI">
                  <p class="file-input-text">
                    {{ POIFileName == "" ? fields?.value?.name : POIFileName }}
                  </p>
                </label>
                <img
                  src="{{
                    POIFileName === ''
                      ? 'assets/icon/upload.svg'
                      : 'assets/icon/see.svg'
                  }}"
                  alt=""
                  class="upload-doc-image"
                  (click)="
                    POIFileName === ''
                      ? null
                      : checkUploadDocment(uploadDocumentsForm.get(fields?.value?.label)?.value,fields?.value?.label)
                  "
                />
                <input
                  type="file"
                  id="fileInputPOI"
                  class="form-control-file"
                  (change)="onFileSelected($event, fields?.value?.label)"
                />
                <input type="hidden" [formControlName]="fields?.value?.label" />
                <div *ngIf="PoiFileInputError" class="error-msg">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
                <div *ngIf="isPoiFileInputError" class="text-danger">
                  Please upload an image (JPG/PNG) or a PDF file.
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showOther">
          <div class="col-12 mt-4">
            <p [ngClass]="{ 'text-center': !isTwoObject }">
              {{ documentOtherText }}
            </p>
          </div>

          <ng-container
            *ngFor="let fields of formFieldOther | keyvalue; let i = index"
           >
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'dropdown'"
            >
              <mat-form-field
                appearance="outline"
                class="document-list mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <mat-select
                  [formControlName]="fields?.value?.lable"
                  (selectionChange)="
                    onSelectionChange($event, fields?.value?.label)
                  "
                >
                  <mat-option
                    *ngFor="let list of fields?.value?.dropdown_list"
                    [value]="list?.key"
                  >
                    {{ list?.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'string'"
            >
              <mat-form-field
                appearance="outline"
                class="document_number mat-input-custom"
              >
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  [formControlName]="fields?.value?.label"
                  matInput
                  aria-label="document_number"
                  class="text-uppercase"
                />
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'dob'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="dobDate"
                  [formControlName]="fields?.value?.label"
                  #dobDateInput
                  appDateFormat
                  [max]="maxDate"
                  [min]="minDate"
                />
                <mat-datepicker-toggle matSuffix [for]="dobDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #dobDate
                  startView="multi-year"
                  id-automation="`${fields?.value?.name}`_id"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="
                fields?.value?.data_type === 'date' &&
                fields?.value?.label === 'doi'
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>{{ fields?.value?.name }} </mat-label>
                <input
                  matInput
                  [matDatepicker]="doiDate"
                  [formControlName]="fields?.value?.label"
                  #doiDateInput
                  appDateFormat
                  [max]="maxDoiDate"
                  [min]="minDoiDate"
                />
                <mat-datepicker-toggle matSuffix [for]="doiDate">
                  <mat-icon matDatepickerToggleIcon>
                    <img
                      src="assets/icon/calendar.svg"
                      class="cursor-pointer mb-2"
                      alt="calendar"
                    />
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker
                  #doiDate
                  startView="multi-year"
                  id-automation="`${fields?.value?.name}`_id"
                ></mat-datepicker>
                <mat-error
                  *ngIf="
                    uploadDocumentsForm
                      .get(fields?.value?.label)
                      ?.hasError('required')
                  "
                >
                  This is a required field.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              [ngClass]="{
                'col-12 col-lg-4': isTwoObject,
                'col-12 col-lg-12': !isTwoObject
              }"
              *ngIf="fields?.value?.data_type === 'upload'"
            >
              <div class="form-group">
                <label class="lable-file-input" for="fileInputOther">
                  <p class="file-input-text">
                    {{
                      OtherFileName == "" ? fields?.value?.name : OtherFileName
                    }}
                  </p>
                </label>
                <img
                  src="{{
                    OtherFileName === ''
                      ? 'assets/icon/upload.svg'
                      : 'assets/icon/see.svg'
                  }}"
                  alt=""
                  class="upload-doc-image"
                  (click)="
                    OtherFileName === ''
                      ? null
                      : checkUploadDocment(uploadDocumentsForm.get(fields?.value?.label)?.value,fields?.value?.label)
                  "
                />
                <input
                  type="file"
                  id="fileInputOther"
                  class="form-control-file"
                  (change)="onFileSelected($event, fields?.value?.label)"
                />
                <input type="hidden" [formControlName]="fields?.value?.label" />
                <div *ngIf="otherfileInputError" class="error-msg">
                  Please upload an image (JPG/PNG).
                </div>
                <div *ngIf="isOtherfileInputError" class="text-danger">
                  Please upload an image (JPG/PNG).
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div [hidden]="isUploadDocment">
        <div class="d-flex justify-content-center mt-3">
          <button
            class="submit-btn continue"
            [disabled]="!uploadDocumentsForm.valid"
            type="submit"
          >
            <img
              src="assets/gif/button-loader.gif"
              alt="close"
              class="loader me-1"
              *ngIf="loader"
            />
            Continue
          </button>
        </div>
      </div>
      <ng-container>
        <div class="col-12" [hidden]="!isUploadDocment">
          <div class="image-main">
            <img [src]="document_url" class="uploaded-image" alt="close" />
          </div>
          <div class="d-flex justify-content-center">
            <label for="fileInput" class="custom-file-upload">
              <img
                src="assets/icon/reupload.svg"
                class="reuploaded-image"
                alt="close"
              />
              Reupload
            </label>
          </div>

          <input
            type="file"
            id="fileInput"
            class="form-control-file"
            formControlName="reupload_document"
            (change)="onFileSelected($event, reUploadFileCOntrolName, true)"
          />
        </div>
        <div class="col-12 mt-4" [hidden]="!isUploadDocment">
          <button
            class="submit-btn continue"
            [disabled]="!isReUploadDocument"
            type="submit"
            (click)="reUploadDone()"
          >
            Continue
          </button>
        </div>
      </ng-container>
    </form>
  </div>
</div>
